import client from './client';

export const listPurchaseReports = (month) =>
  client.get('/purchase-reports', { params: { month } }).then((r) => r.data);
export const createPurchaseReport = (date) => client.post('/purchase-reports', { date }).then((r) => r.data);
export const ensureMonthPurchaseReports = (month) =>
  client.post('/purchase-reports/ensure-month', { month }).then((r) => r.data);
export const updatePurchaseReport = (id, rows) =>
  client.patch(`/purchase-reports/${id}`, { rows }).then((r) => r.data);
export const removePurchaseReport = (id) => client.delete(`/purchase-reports/${id}`).then((r) => r.data);
export const getPurchaseMonthNote = (month) =>
  client.get('/purchase-reports/month-note', { params: { month } }).then((r) => r.data);
export const savePurchaseMonthNote = (month, content) =>
  client.put('/purchase-reports/month-note', { month, content }).then((r) => r.data);
export const getPurchaseWeekStatus = () => client.get('/purchase-reports/week-status').then((r) => r.data);
export const submitPurchaseWeek = () => client.post('/purchase-reports/submit-week').then((r) => r.data);
